import { Col, Row, Input, Divider } from 'antd';
import * as React from 'react';
import LanguageSelect from '../../../components/Others/LanguageSelect';
import { Title } from '../../../components/Layout/components';
import Form, { FormItem } from '../../../components/Form';
import TextArea from 'antd/lib/input/TextArea';
import { Wysiwyg } from '../../../components/Form/components';

interface IStoreDetailProps {
    store: GQL.IStore;
    onSave: (store: GQL.IStore) => void;
    onCancel: () => void;
    languages: Array<GQL.ILanguage>;
}

interface IStoreDetailState {
    store: GQL.IStore;
    currentLanguage: string;
}

export default class StoreDetail extends React.Component<IStoreDetailProps, IStoreDetailState> {

    public constructor(props: IStoreDetailProps) {
        super(props);

        this.state = {
            store: props.store || {},
            currentLanguage: props.languages.map(l => l.value)[0],
        };

        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
    }

    public render() {
        const { languages } = this.props;
        const { store, currentLanguage } = this.state;

        const openingTimes = store.openingTimes && store.openingTimes[currentLanguage] || {};

        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        return (
            <div>
                <Title
                    languages={languages}
                    currentLanguage={this.state.currentLanguage}
                    onChange={(l: string) => { this.setState({ currentLanguage: l }); }} 
                >
                    {this.props.store == undefined ? 'New store' : `Store "${store.name}"`}
                </Title>
                <Divider />
                <Row>
                    <Col span={24}>
                        <Form
                            onCancel={this.props.onCancel}
                            onSubmit={this.save}
                        >
                            <FormItem
                                label={'Name'}
                                required={true}
                            >
                                <Input
                                    name={'name'}
                                    autoFocus={true}
                                    placeholder="Internal name"
                                    addonBefore={'Internal'}
                                    defaultValue={store && store.name || ''}
                                    required={true}
                                    onChange={this.onChange}
                                />
                            </FormItem>
                            <Row>
                                <Col span={24} md={12}>
                                    <FormItem
                                        label={'Title - ' + this.state.currentLanguage}
                                        required={true}
                                    >
                                        <Input
                                            key={this.state.currentLanguage}
                                            name={'title'}
                                            placeholder={'Title in store`s page'}
                                            addonBefore={this.state.currentLanguage}
                                            defaultValue={this.state.store.title && this.state.store.title[this.state.currentLanguage] || ''}
                                            required={true}
                                            onChange={e => this.onChange(e, this.state.currentLanguage)}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={24} md={12} className="md-p-l-15">
                                    <FormItem
                                        label={'URL slug - ' + this.state.currentLanguage}
                                        required={true}
                                    >
                                        <Input
                                            key={this.state.currentLanguage}
                                            name={'slug'}
                                            placeholder={'Slug to store`s page URL'}
                                            addonBefore={this.state.currentLanguage}
                                            defaultValue={this.state.store.slug && this.state.store.slug[this.state.currentLanguage] || ''}
                                            required={true}
                                            onChange={(e: any) => this.onChange(e, this.state.currentLanguage)}
                                        />
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem
                                label={'Subtitle - ' + this.state.currentLanguage}
                            >
                                <Input
                                    key={this.state.currentLanguage}
                                    name={'subtitle'}
                                    placeholder={'Subtitle in store`s page'}
                                    addonBefore={this.state.currentLanguage}
                                    defaultValue={this.state.store.subtitle && this.state.store.subtitle[this.state.currentLanguage] || ''}
                                    onChange={e => this.onChange(e, this.state.currentLanguage)}
                                />
                            </FormItem>

                            <FormItem
                                label={'Description - ' + this.state.currentLanguage}
                            >
                                <Wysiwyg 
                                    name={'description'}
                                    value={this.state.store.description && this.state.store.description[this.state.currentLanguage] || null}
                                    onChange={e => this.onChange(e, this.state.currentLanguage)}
                                />
                            </FormItem>

                            <Row>
                                <Col span={24} md={10}>
                                    <FormItem
                                        label={'Address - ' + this.state.currentLanguage}
                                    >
                                        <Input
                                            key={this.state.currentLanguage}
                                            name={'address'}
                                            placeholder={'Address'}
                                            addonBefore={this.state.currentLanguage}
                                            defaultValue={this.state.store.address && this.state.store.address[this.state.currentLanguage] || ''}
                                            onChange={e => this.onChange(e, this.state.currentLanguage)}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={24} md={7} className="md-p-l-15 md-p-r-15">
                                    <FormItem
                                        label={'Phone - ' + this.state.currentLanguage}
                                    >
                                        <Input
                                            key={this.state.currentLanguage}
                                            name={'phone'}
                                            placeholder={'Phone'}
                                            addonBefore={this.state.currentLanguage}
                                            defaultValue={this.state.store.phone && this.state.store.phone[this.state.currentLanguage] || ''}
                                            onChange={e => this.onChange(e, this.state.currentLanguage)}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={24} md={7}>
                                    <FormItem
                                        label={'Email - ' + this.state.currentLanguage}
                                    >
                                        <Input
                                            key={this.state.currentLanguage}
                                            name={'email'}
                                            placeholder={'Email'}
                                            addonBefore={this.state.currentLanguage}
                                            defaultValue={this.state.store.email && this.state.store.email[this.state.currentLanguage] || ''}
                                            onChange={e => this.onChange(e, this.state.currentLanguage)}
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            
                            <FormItem
                                label={'Opening times - ' + this.state.currentLanguage}
                            >
                                {days && days.map((day: string) => 
                                    <div key={day}>
                                        <Input
                                            name={'openingTimes'}
                                            placeholder={day}
                                            addonBefore={this.state.currentLanguage}
                                            defaultValue={openingTimes && openingTimes[day.toLowerCase()] || ''}
                                            onChange={e => this.onChangeOpeningTime(e, day.toLowerCase(), this.state.currentLanguage)}
                                            style={{ maxWidth: '300px' }}
                                        />
                                    </div>)}
                            </FormItem>

                            <FormItem
                                label={'Priority'}
                            >
                                <Input
                                    name={'priority'}
                                    placeholder={'Priority'}
                                    defaultValue={this.state.store.priority && this.state.store.priority > 0 ? this.state.store.priority.toString() : ''}
                                    onChange={e => this.onChange(e)}
                                />
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }

    private onChange(e: any, language?: string) {
        const newValue = (language 
            ? { [e.target.name]: { [language]: e.target.value }} 
            : { [e.target.name]: e.target.value });
        this.setState({
            store: { ...this.state.store, ...newValue }
        });
    }

    private onChangeOpeningTime(e: any, day: string, language: string) {
        const newValue = {...this.state.store.openingTimes || {}};
        if (!newValue[language]) {
            newValue[language] = {};
        }
        newValue[language][day] = e.target.value;

        this.setState({
            store: {...this.state.store, openingTimes: newValue}
        });
    }

    private async save() {
        this.props.onSave(this.state.store);
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Stores/StoreDetail/StoreDetail.tsx